// Where an admin opens a Case in the telehealth vendor (MDI) (XCUT-R23).
export const telehealthCaseUrl = (caseId: string) =>
  `https://app.mdintegrations.com/tabs/cases/${caseId}`;
